export const serverURL = "https://gptext.behind.ai:5004"
//export const serverURL = "http://localhost:5003"
//export const serverURL_payments = "http://localhost:4242"
export const serverURL_payments = "https://gptext.behind.ai:4242"
export const extensionURL = "https://chrome.google.com/webstore/detail/gpt-write/iahjdhcoigkpcpjeoflmkpalepmldigi"